var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import commonMessages from '../../common/messages';
import Button from '../../components/button/Button';
import TextInput from '../../components/text-input/TextInput';
import Tooltip from '../../components/tooltip/Tooltip';
import IconInfo from '../../icons/general/IconInfo';

import messages from './messages';

import './CustomInstanceNewField.scss';

var CustomInstanceNewField = function (_React$PureComponent) {
    _inherits(CustomInstanceNewField, _React$PureComponent);

    function CustomInstanceNewField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CustomInstanceNewField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomInstanceNewField.__proto__ || Object.getPrototypeOf(CustomInstanceNewField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            key: '',
            value: '',
            error: ''
        }, _this.onKeyChange = function (event) {
            _this.onChange(event, 'key');
        }, _this.onValueChange = function (event) {
            _this.onChange(event, 'value');
        }, _this.onAdd = function () {
            var _this$state = _this.state,
                key = _this$state.key,
                value = _this$state.value;
            var _this$props = _this.props,
                onAdd = _this$props.onAdd,
                properties = _this$props.properties;

            if (Object.prototype.hasOwnProperty.call(properties, key)) {
                _this.setState({
                    error: React.createElement(FormattedMessage, messages.customErrorDuplicateKey)
                });
            } else if (key.startsWith('$')) {
                _this.setState({
                    error: React.createElement(FormattedMessage, messages.customErrorInternalKey)
                });
            } else if (key) {
                onAdd(key, value);
            } else {
                _this.setState({
                    error: React.createElement(FormattedMessage, messages.customErrorRequired)
                });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CustomInstanceNewField, [{
        key: 'onChange',


        /**
         * Common change handler
         *
         * @param {Event} event - keyboard event
         * @param {string} attr - key or value
         * @return {void}
         */
        value: function onChange(event, attr) {
            var currentTarget = event.currentTarget;
            this.setState(_defineProperty({
                error: ''
            }, attr, currentTarget.value));
        }

        /**
         * Change handler for the key
         *
         * @param {Event} event - keyboard event
         * @return {void}
         */


        /**
         * Change handler for the value
         *
         * @param {Event} event - keyboard event
         * @return {void}
         */


        /**
         * Persists the new metadata added or shows an error
         *
         * @return {void}
         */

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                intl = _props.intl,
                isCancellable = _props.isCancellable,
                onCancel = _props.onCancel;
            var _state = this.state,
                key = _state.key,
                value = _state.value,
                error = _state.error;

            return React.createElement(
                'div',
                { className: 'custom-new-field' },
                React.createElement(
                    'div',
                    { className: 'custom-new-field-header' },
                    React.createElement(FormattedMessage, _extends({
                        tagName: 'h5'
                    }, messages.customNewField)),
                    React.createElement(
                        Tooltip,
                        {
                            text: React.createElement(FormattedMessage, messages.customNewFieldMessage)
                        },
                        React.createElement(
                            'div',
                            { tabIndex: '-1' },
                            React.createElement(IconInfo, { color: '#777', width: 18, height: 18 })
                        )
                    )
                ),
                React.createElement(TextInput, {
                    error: error,
                    label: React.createElement(FormattedMessage, messages.customKey),
                    isRequired: true,
                    onChange: this.onKeyChange,
                    placeholder: intl.formatMessage(messages.customKeyPlaceholder),
                    type: 'text',
                    value: key
                }),
                React.createElement(TextInput, {
                    hideOptionalLabel: true,
                    label: React.createElement(FormattedMessage, messages.customValue),
                    onChange: this.onValueChange,
                    placeholder: intl.formatMessage(messages.customValuePlaceholder),
                    type: 'text',
                    value: value
                }),
                React.createElement(
                    'div',
                    { className: 'custom-new-field-actions' },
                    isCancellable && React.createElement(
                        Button,
                        {
                            type: 'button',
                            'data-resin-target': 'metadata-customfieldcancel',
                            onClick: onCancel
                        },
                        React.createElement(FormattedMessage, commonMessages.cancel)
                    ),
                    React.createElement(
                        Button,
                        {
                            type: 'button',
                            'data-resin-target': 'metadata-customfieldadd',
                            onClick: this.onAdd
                        },
                        React.createElement(FormattedMessage, messages.customAdd)
                    )
                )
            );
        }
    }]);

    return CustomInstanceNewField;
}(React.PureComponent);

CustomInstanceNewField.propTypes = {
    intl: function intl(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
            throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
        }
    },
    isCancellable: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    properties: function properties() {
        return (typeof bpfrpt_proptype_Fields === 'function' ? bpfrpt_proptype_Fields.isRequired ? bpfrpt_proptype_Fields.isRequired : bpfrpt_proptype_Fields : PropTypes.shape(bpfrpt_proptype_Fields).isRequired).apply(this, arguments);
    }
};


export { CustomInstanceNewField as CustomInstanceNewFieldBase };
export default injectIntl(CustomInstanceNewField);
import { bpfrpt_proptype_Fields } from './flowTypes';
import { bpfrpt_proptype_FieldValue } from './flowTypes';
import PropTypes from 'prop-types';